import React, { useEffect, lazy, Suspense } from 'react'
import Footer from '../components/Footer'
import { Box, Skeleton, Spinner } from '@chakra-ui/react'
// import video from 'public/videos/IMG_2191.mp4'
import Carousel3D from '../components/Carousel'
import FixedBg from '../components/FixedBg'
import WelcomePart from '../components/WelcomePart'
import Features from '../components/Features'
import TextImageBlock from '../components/TextImageBlock'
import { cards } from '../mockedData'
import { useParams } from 'react-router-dom'
import { useTranslation } from 'react-i18next'
import company from '../assets/companyy.jpg'
import { Helmet } from 'react-helmet'
const Hero = lazy(() => import('../components/Hero'))
const Header = lazy(() => import('../components/Header'))

const Home = () => {
  const { id } = useParams()
  const { t, i18n } = useTranslation('common')

  useEffect(() => {
    const video = document.getElementById('hero-video')
    if (video) {
      const playPromise = video.play()
      if (playPromise !== undefined) {
        playPromise.catch(() => {
          document.addEventListener(
            'touchstart',
            () => video.play(),
            { once: true }
          )
        })
      }
    }
  }, [])

  useEffect(() => {
    window.scrollTo({
      top: 0,
      left: 0,
      behavior: 'smooth',
    })
  }, [id])
  useEffect(() => {
    window.scrollTo({
      top: 0,
      behavior: 'smooth',
    })
  })
  return (
    <>
      <Helmet>
        <title>Errifire Armenia – Electric & Bioethanol Fireplaces</title>
        <meta
          name="description"
          content="Premium electric fireplaces in Armenia. Modern design, safe heating, professional installation."
        />
        <meta property="og:title" content="Errifire Armenia" />
        <meta property="og:description" content="Premium fireplaces, modern fire solutions." />
        {/* <meta property="og:image" content="https://errifire.com/og-image.jpg" /> */}
        <meta property="og:type" content="website" />
      </Helmet>
      <Box position="relative">
        <Box
          as="video"
          objectFit="cover"
          height={{ base: '650px', sm: '650px', md: '800px', xl: '100vh' }}
          loop
          muted
          width="100%"
          playsInline
          autoPlay
          preload="none"
          oster="/background.jpg" // optional fallback
          src="/videos/IMG_2191.mp4"
        />
        <Box
          position="absolute"
          width="100%"
          bgColor="rgba(255,255,255,.1)"
          height={{ base: '650px', sm: '650px', md: '800px', xl: '100vh' }}
          top="0"
        >
          <Suspense fallback={
            // Subtle placeholder covering the hero area
            <Box position="absolute" top={0} w="100%" h={{ base: '650px', md: '800px', xl: '100vh' }}>
              <Skeleton height="100%" width="100%" startColor="gray.100" endColor="gray.200" />
            </Box>
          }>
            <Header t={t} i18n={i18n} />
            <Hero t={t} />
          </Suspense>
        </Box>
      </Box>
      <WelcomePart t={t} />
      <FixedBg bgImage="../../assets/smartmockup.jpg" />
      <Box maxW={{ base: 'unset', md: '1600px' }} mx="auto" mt={{ base: '120px', md: '150px' }}>
        <TextImageBlock
          textOrder={{ base: '0', md: '1' }}
          seemore={t('product.button')}
          title={t('about.title')}
          description={t('about.description')}
          imageUrl={company}
        />
      </Box>
      <Carousel3D t={t} cards={cards} />
      <FixedBg bgImage="../../assets/smartmockup.jpg" />
      <Features t={t} />
      <Footer t={t} />
    </>
  )
}

export default Home
